<app-shell>
  <router-outlet></router-outlet>

  <footer style="text-align: center; padding-top: 50px; padding-bottom: 20px;">
    <cite>powered by google <img width="20px" src="./../../../assets/google-fit.svg"> firebase, angular, material.</cite>
  </footer>
</app-shell>